document.addEventListener('DOMContentLoaded', () => {
    const navContainer = document.querySelector('.av-retail-m-nav-container') as HTMLElement
    const navbarComponent = document.querySelector('.DVWebNode-retail-nav-wrapper') as HTMLElement
    const navBarInitialOffset = (typeof navbarComponent !== 'undefined' &&
      typeof navbarComponent.offsetTop !== 'undefined')
      ? navbarComponent.offsetTop : 0

    /*
        On MShop, the sticky nav scroll to top cuts off everything beneath

        SIM: https://sim.amazon.com/issues/AVWebSNB-2574

        The reason is: as soon as the navigation container assumes a fixed
        position, the element underneath jumps into the space it empties.

        This solution adds a pseudo-element where the actual nav container
        was, before it goes sticky.

        There may be a better solution, opting for this one because of the
        time-critical nature of this project.
    */

    // Check if the sticky flag is on
    if (typeof navContainer !== 'undefined' &&
      typeof navContainer.dataset !== 'undefined' &&
      navContainer.dataset.sticky === 'true') {
      // Browser supports sticky element
      if (typeof CSS !== 'undefined' &&
        typeof CSS.supports !== 'undefined' &&
        CSS.supports('position: sticky')) {
        navbarComponent.classList.add('av-native-stick')
      } else {
        let pseudoDiv = document.createElement("div")
        pseudoDiv.id = "pseudodiv"
        pseudoDiv.style.height = `${navContainer ? navContainer.clientHeight : 0}px`
        pseudoDiv.style.display = "none"
        navbarComponent.parentNode.insertBefore(pseudoDiv, navbarComponent)
        const pseudoDivElement = document.querySelector('#pseudodiv') as HTMLElement

        // For unsupported browsers, simulate
        window.addEventListener('scroll', () => {
          if (window.pageYOffset >= navBarInitialOffset) {
            pseudoDivElement.style.display = "inline-block"
            navbarComponent.classList.add('av-nav-sticky')
          } else {
            pseudoDivElement.style.display = "none"
            navbarComponent.classList.remove('av-nav-sticky')
          }
        })
      }
    }
  })
